import { IPage, IPageView } from "../models"

import { usePageParameters } from "./usePageParameters.hook"

export const PageDataContextInitializer = ({ page, pageView }: {
    page: IPage,
    pageView: IPageView,
}) => {
    // Use the usePageParameters hook to manage page parameters
    usePageParameters({ page, pageView })

    return <></>
}
